<template>
  <div v-if="onlyShowPopup==null" @click="showSelectDate" style="display: flex;flex-direction: row" :style="style">
    <div class="tHDatePickerParentDiv">
      <div class="leftTextStyle" :style="{
            padding: smallType?'4px 4px':'7px 8px',
            backgroundColor:hcf.getMainColor()+'1a',
        }">
        <div :style="hcf.getTextStyle({
        color:'main',
    })">
          {{ selectStartDate }}
        </div>
        <div :style="hcf.getTextStyle({
        marginLeft:smallType?1:5,marginRight:smallType?1:5,color:'main',
    })">
          至
        </div>
        <div :style="hcf.getTextStyle({
        color:'main',
    })">
          {{ selectEndDate }}
        </div>
      </div>
    </div>
    <div class="rightTextStyle"  :style="{
            padding: smallType?'4px 4px':'7px 8px',
        }">
      <div :style="hcf.getTextStyle({
        color:'white',addSize:smallType?0:1,
    })">
        {{ showRightDurDaysText }}
      </div>
    </div>
  </div>
  <van-calendar v-if="onlySelectUI == null" v-model:show="showSelectModal" type="range" @confirm="onConfirm"
                :min-date="minDate" :max-date="maxDate" :default-date="getDefaultOpenDate"
  />
</template>


<script setup>
  import {emitter, hcf} from "@/components/utils/HComFunctions.js";

  const props = defineProps(["style","change","onlyShowPopup","onlySelectUI","smallType","tag"]);
  onMounted(()=>{
    if(props.onlyShowPopup){
        emitter.on("EVENT_LISTEN_SPECIAL_SHOW_DATE_PICK"+props.tag??"",()=>{
          showSelectModal.value = true;
        });
    }
    if(props.onlySelectUI){
      emitter.on("EVENT_LISTEN_SPECIAL_UPDATE_DATE_PICK"+props.tag??"",(values)=>{
        onConfirm(values);
      });

    }
  });
  onUnmounted(()=>{
    if(props.onlyShowPopup){
      emitter.off("EVENT_LISTEN_SPECIAL_SHOW_DATE_PICK"+props.tag??"");
    }
    if(props.onlySelectUI){
      emitter.off("EVENT_LISTEN_SPECIAL_UPDATE_DATE_PICK"+props.tag??"");
    }
  });

  //默认最大选择的日期范围 30天
  const minDate = new Date(Date.now() - 86400 * 1000 * 29);
  const maxDate = new Date(Date.now());

  //默认打开的时候的日期
  const getDefaultOpenDate = computed(() => {
    if (selectStartDate.value === "") {
      return [new Date(Date.now() - 86400 * 1000 * 2), new Date(Date.now())];
    }
  });

  const selectStartDate = ref(hcf.getDateByMillSecs(Date.now() / 1000 - 86400 * 2));
  const selectEndDate = ref(hcf.getDateByMillSecs(Date.now() / 1000));

  const showSelectModal = ref(false);

  const showRightDurDaysText = ref("近3天");

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const onConfirm = (values) => {
    const [start, end] = values;
    showSelectModal.value = false;
    selectStartDate.value = formatDate(start);
    selectEndDate.value = formatDate(end);

    // 设置右侧文案：共几天
    const days = getDateDiffInDays(start, end);
    if (endDayIsCurDay()) {
      showRightDurDaysText.value = `近${days}天`;
    } else {
      showRightDurDaysText.value = `共${days}天`;
    }

    let startSecs = getDayTimestamp(selectStartDate.value);
    let endSecs = getDayTimestamp(selectEndDate.value,false);
    if(endDayIsCurDay()){
      endSecs = Math.floor(Date.now()/1000);
    }

    if(props.onlyShowPopup){
      emitter.emit("EVENT_LISTEN_SPECIAL_UPDATE_DATE_PICK"+props.tag??"",values);
    }else{
      props.change(startSecs,endSecs);
    }
  };

  function showSelectDate() {
    if(props.onlySelectUI){
      emitter.emit("EVENT_LISTEN_SPECIAL_SHOW_DATE_PICK"+props.tag??"");
    }else{
      showSelectModal.value = true;
    }
  }

  function endDayIsCurDay(){
    const today = new Date();
    today.setHours(0, 0, 0, 0); // 清除时间部分，只保留日期
    const endDay = new Date(selectEndDate.value);
    endDay.setHours(0, 0, 0, 0);
    return endDay.getTime() === today.getTime();
  }

  // const startTimestamp = getDayTimestamp('2020-04-02', true)   // 00:00:00 的时间戳
  // const endTimestamp = getDayTimestamp('2020-04-02', false)    // 23:59:59 的时间戳
  function getDayTimestamp(dateStr, isStartOfDay = true) {
    const date = new Date(dateStr)

    if (isStartOfDay) {
      date.setHours(0, 0, 0, 0)
    } else {
      date.setHours(23, 59, 59, 999)
    }

    return Math.floor(date.getTime() / 1000)
  }

  //计算两个时间相差几天
  function getDateDiffInDays(start, end) {
    const diffInMs = end.getTime() - start.getTime();
    return Math.floor(diffInMs / (1000 * 60 * 60 * 24)) + 1; // +1 表示包含起始日
  }

</script>


<style scoped>
  .leftTextStyle {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border: var(--ct-main-color) 1px solid;display:flex;
  }

  .rightTextStyle {
    display: flex;
    background-color: var(--ct-main-color);
    align-items: center;
    justify-content: center;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .tHDatePickerParentDiv {
    display: inline-flex;
    flex-direction: row;
  }

</style>
